import { ChevronIcon, IconButton } from '@mgh-app/component-library';
import {
  backgroundColor,
  borderColor,
  borderRadius,
  borders,
  borderStyle,
  display,
  dropShadow,
  gridTemplateColumns,
  gridTemplateRows,
  height,
  justifyItems,
  padding,
  rotate,
  twCls,
  width,
} from 'style';

export interface ChangeButtonProps {
  onClick?: () => void;
  variant: 'UP' | 'DOWN';
}

export const ChangeButton = ({ onClick, variant }: ChangeButtonProps) => (
  <IconButton
    className={twCls(
      width('w-7'),
      height('h-7'),
      borderStyle('border-solid'),
      borders('border-t'),
      borderColor('border-t-grey-300'),
      borderRadius('rounded-full'),
      backgroundColor('bg-white', 'hover:bg-white'),
      dropShadow('drop-shadow-home'),
      padding('px-2', 'pb-1', 'pt-2'),
      display('grid'),
      gridTemplateRows('grid-rows-min-fc'),
      gridTemplateColumns('grid-cols-1'),
      justifyItems('justify-items-center'),
    )}
    onClick={onClick}
  >
    <ChevronIcon
      className={twCls(variant === 'DOWN' ? rotate('rotate-180') : rotate('rotate-0'))}
    />
  </IconButton>
);
